import { render } from "./Home.vue?vue&type=template&id=d661bae0&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=d661bae0&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\mm\\Documents\\__Kundenprojekte\\ÜIM-HAB\\Entwicklung\\Frontend\\uebersetzen\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d661bae0"]])

export default __exports__